import React from 'react';
import { SuccessIcon } from 'components/common/icons';
import { BaseAlert } from './baseAlert';
import { alertClasses, alertTypes } from '../constants';

export const SuccessAlert = props => (
  <BaseAlert
    {...props}
    icon={SuccessIcon}
    className={alertClasses[alertTypes.SUCCESS]}
  />
);

export default SuccessAlert;
